import { DatePipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { environment } from "src/environments/environment";
import { MyserviceService } from "../myservice.service";
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as FileSaver from 'file-saver';
import { Workbook } from 'exceljs/dist/exceljs.min.js';
import * as moment from "moment";

@Component({
    selector: "app-m-dashboard",
    templateUrl: "./m-dashboard.component.html",
    styleUrls: ["./m-dashboard.component.css"],
    providers: [DatePipe],
})
export class MDashboardComponent implements OnInit {
    @ViewChild('screen', { static: false }) screen: ElementRef;
    @ViewChild('inbound', { static: false }) inbound: ElementRef;
    @ViewChild('outbound', { static: false }) outbound: ElementRef;

    statusArray = [];
    transactionArray = [];
    tradingPartnerOptions = [];
    inboundPieChart: any;
    outboundPieChart: any;
    today = Date.now();
    selected;
    restData: any = "";
    dashboard: any = {};
    allTradingPartner = [];
    userRole: string;
    excelDisable:boolean;
    pdfDisable:boolean;
    inboundVolumeCount:number=0;
    outboundVolumeCount:number=0;
    dateType :any
    dateTypeList = [
        {label : 'Custom Range' ,value: 'Custom Range'},
        {label : 'Last 30 Days' ,value: 'Last 30 Days'},
        {label : 'Last 7 Days' ,value: 'Last 7 Days'},
        {label : 'Today' ,value: 'Today'},
        {label : 'Yesterday' ,value: 'Yesterday'}
    ]
    alwaysShowCalendars: boolean;
    ranges: any = {
        'Today': [ moment().startOf('day'), moment().endOf('day') ],
        'Yesterday': [ moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
        'Last 7 Days': [ moment().subtract(6, 'days').startOf('day'), moment().endOf('day') ],
        'Last 30 Days': [ moment().subtract(29, 'days').startOf('day'), moment().endOf('day') ],
        'This Month': [ moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day') ],
        'Last Month': [
          moment().subtract(1, 'month').startOf('month').startOf('day'),
          moment().subtract(1, 'month').endOf('month').endOf('day')      
        ]
      };    

    constructor(
        public localstorage: LocalStorageService,
        public session: SessionStorageService,
        private http: HttpClient,
        public datepipe: DatePipe,
        private myservice: MyserviceService
    ) { }

    ngOnInit() {
        this.userRole = this.session.retrieve("userRole");
        this.allTradingPartners();
        this.setToDefault();
    }

    generate(dashboard) {
        this.inboundVolumeCount=0;
        this.outboundVolumeCount=0;
        this.dashboard.fromDate = this.datepipe.transform(
            this.selected.startDate,
            "MM/dd/yyyy HH:mm"
        );
        this.dashboard.toDate = this.datepipe.transform(
            this.selected.endDate,
            "MM/dd/yyyy HH:mm"
        );
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .post(
                environment.apiUrl + "/dashboards/dashboard",
                dashboard.tpId==="All"?dashboard:{...dashboard,tpId:dashboard.tpId.value},
                { headers: headers }
            )
            .subscribe((data) => {
                this.restData = data;

                let inBoundLabelList = [];
                let inBoundDatalList = [];
                let ibColors = [];
                this.restData.inbound.forEach((element) => {
                    inBoundLabelList.push(element.name);
                    inBoundDatalList.push(element.count);
                    ibColors.push(this.getRandomColor());
                    //to get the count of inbound volumes
                    this.inboundVolumeCount+=parseInt(element.count);
                });

                let outBoundLabelList = [];
                let outBoundDataList = [];
                let obColors = [];
                this.restData.outbound.forEach((element) => {
                    outBoundLabelList.push(element.name);
                    outBoundDataList.push(element.count);
                    obColors.push(this.getRandomColor());
                    //to get the count of outbound volumes
                    this.outboundVolumeCount+=parseInt(element.count);
                });

                this.inboundPieChart = {
                    labels: inBoundLabelList,
                    datasets: [
                        {
                            data: inBoundDatalList,
                            backgroundColor: ibColors,
                        },
                    ],
                };

                this.outboundPieChart = {
                    labels: outBoundLabelList,
                    datasets: [
                        {
                            data: outBoundDataList,
                            backgroundColor: obColors,
                        },
                    ],
                };
            });
    }

    getRandomColor() {
        var color = Math.floor(0x1000000 * Math.random()).toString(16);
        return "#" + ("000000" + color).slice(-6);
    }

    setToDefault() {
        this.restData = "";
        let today = this.myservice.getDateByTZ();
        this.selected = {
            startDate: new Date(
                today.getUTCFullYear(),
                today.getUTCMonth(),
                today.getUTCDate(),
                0,
                0,
                0
            ),
            endDate: new Date(
                today.getUTCFullYear(),
                today.getUTCMonth(),
                today.getUTCDate(),
                23,
                59,
                0
            ),
        };
        this.statusArray = this.myservice.getStatus();
        this.transactionArray = this.myservice.getDocumentTypes(
            this.localstorage.retrieve("token"),
            "M",
            "LIVE"
        );
        this.dashboard.status = "-1";
        this.dashboard.tpId = "All";
        this.dashboard.docType = "-1";
    }
    exportToExcel(dashboard) {
        this.excelDisable=true;
        this.dashboard = dashboard;
        this.dashboard.flag = "L";
        this.dashboard.downloadType = "excel";
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .post(environment.apiUrl + "/dashboards/downloadExcelPdfData", dashboard.tpId==="All"?dashboard:{...dashboard,tpId:dashboard.tpId.value}, {
                headers: headers,
            })
            .subscribe(
                (response: any) => {
                    html2canvas(this.screen.nativeElement).then(canvas => {
                        var date = this.myservice.getDateByTZ()
                        const img = canvas.toDataURL();
                        let workbook = new Workbook();
                        let worksheet = workbook.addWorksheet('Reports');
                        //For chart heading
                        worksheet.mergeCells('F1:N3');
                        worksheet.getCell('F1').value = `Dashboard Pie Reports on : ${this.datepipe.transform(date, "short","+0000")}`
                        worksheet.getCell('F1').font = { size: 15, bold: true }
                        worksheet.getCell('F1').alignment = { vertical: 'middle', horizontal: 'center' }
                        //for grid heading
                        worksheet.mergeCells('F25:N27');
                        worksheet.getCell('F25').value = `Dashboard Inbound and Outbound Reports`
                        worksheet.getCell('F25').font = { size: 15, bold: true }
                        worksheet.getCell('F25').alignment = { vertical: 'middle', horizontal: 'center' }
                        let chartImage = workbook.addImage({
                            base64: img,
                            extension: 'png',
                        });
                        worksheet.addImage(chartImage, 'C5:Q22');
                        worksheet.mergeCells('D29:H30');
                        worksheet.getCell('D29').value = "Inbound Reports"
                        worksheet.getCell('D29').font = { size: 13, bold: true }
                        worksheet.getCell('D29').alignment = { vertical: 'middle', horizontal: 'center' }
                        //for inbound header
                        worksheet.mergeCells('M29:Q30');
                        worksheet.getCell('M29').value = "Outbound Reports"
                        worksheet.getCell('M29').font = { size: 13, bold: true }
                        worksheet.getCell('M29').alignment = { vertical: 'middle', horizontal: 'center' }
                        //for inboound table header
                        worksheet.getCell('C32').value = 'Partner Name'
                        worksheet.mergeCells('C32:F33')
                        worksheet.getCell('C32').alignment = { horizontal: 'center' }
                        worksheet.getCell('C32').font = { bold: true }
                        worksheet.getCell('G32').value = 'Inbound Doc Count'
                        worksheet.mergeCells('G32:I33')
                        worksheet.getCell('G32').alignment = { horizontal: 'center' }
                        worksheet.getCell('G32').font = { bold: true }
                        //for outbound table header
                        worksheet.getCell('L32').value = 'Partner Name'
                        worksheet.mergeCells('L32:O33')
                        worksheet.getCell('L32').alignment = { horizontal: 'center' }
                        worksheet.getCell('L32').font = { bold: true }
                        worksheet.getCell('P32').value = 'Outbound Doc Count'
                        worksheet.mergeCells('P32:R33')
                        worksheet.getCell('P32').alignment = { horizontal: 'center' }
                        worksheet.getCell('P32').font = { bold: true }
                        //for inbound table rows
                        for (let index = 0; index < response.inbound.length; index++) {
                            worksheet.getCell(`C${34 + index}`).value = response.inbound[index][0]
                            worksheet.mergeCells(`C${34 + index}:F${34 + index}`)
                            worksheet.getCell(`G${34 + index}`).value = response.inbound[index][1]
                            worksheet.mergeCells(`G${34 + index}:I${34 + index}`)
                        }
                        //for outbound table rows
                        for (let index = 0; index < response.outbound.length; index++) {
                            worksheet.getCell(`L${34 + index}`).value = response.outbound[index][0]
                            worksheet.mergeCells(`L${34 + index}:O${34 + index}`)
                            worksheet.getCell(`P${34 + index}`).value = response.outbound[index][1]
                            worksheet.mergeCells(`P${34 + index}:R${34 + index}`)
                        }
                        //for showing inbound volumes count
                        worksheet.getCell(`C${34 + response.inbound.length}`).value = "Total inbound volumes"
                        worksheet.mergeCells(`C${34 + response.inbound.length}:F${34 + response.inbound.length}`)
                        worksheet.getCell(`G${34 + response.inbound.length}`).value = this.inboundVolumeCount
                        worksheet.mergeCells(`G${34 + response.inbound.length}:I${34 + response.inbound.length}`)
                        worksheet.getCell(`C${34 + response.inbound.length}`).font = { bold: true }
                        worksheet.getCell(`G${34 + response.inbound.length}`).font = { bold: true }
                        //for showing outbound volumes count
                        worksheet.getCell(`L${34 + response.outbound.length}`).value = "Total outbound volumes"
                        worksheet.mergeCells(`L${34 + response.outbound.length}:O${34 + response.outbound.length}`)
                        worksheet.getCell(`P${34 + response.outbound.length}`).value = this.outboundVolumeCount
                        worksheet.mergeCells(`P${34 + response.outbound.length}:R${34 + response.outbound.length}`)
                        worksheet.getCell(`L${34 + response.outbound.length}`).font = { bold: true }
                        worksheet.getCell(`P${34 + response.outbound.length}`).font = { bold: true }
                        //for saving file
                        workbook.xlsx.writeBuffer().then((data: BlobPart) => {
                            let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            FileSaver.saveAs(blob, "TP_Volumes_Reports_" + this.datepipe.transform(date, "ddMMyyyy_HHmm","+0000"));
                            this.excelDisable=false;
                        })
                    });
                },(error) => {
                    //console.log("Error occured" + error);
                    this.excelDisable=false;
                })
    }
    exportToPdf(dashboard) {
        this.pdfDisable=true;
        var date = this.myservice.getDateByTZ()
        this.dashboard = dashboard;
        this.dashboard.flag = "M";
        this.dashboard.downloadType = "pdf";
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .post(environment.apiUrl + "/dashboards/downloadExcelPdfData", dashboard.tpId==="All"?dashboard:{...dashboard,tpId:dashboard.tpId.value}, {
                headers: headers,
            })
            .subscribe(
                (response: any) => {
                    let PDF = new jsPDF('p', 'mm', 'a4');
                    html2canvas(this.inbound.nativeElement).then(canvasInbound => {
                        const inbound = canvasInbound.toDataURL();
                        html2canvas(this.outbound.nativeElement).then(canvasOutbound => {
                            const outbound = canvasOutbound.toDataURL();
                            PDF.setFontSize(18);
                            PDF.text(`Dashboard Pie Reports on : ${this.datepipe.transform(date, "short","+0000")}`, 48, 35);
                            PDF.addImage(inbound, 'PNG', 10, 45, 190, 100);
                            PDF.addImage(outbound, 'PNG', 10, 150, 190, 100);
                            PDF.addPage();
                             PDF.text(`Dashboard Inbound and Outbound Reports`, 48, 35);
                            PDF.setFontSize(14);
                            PDF.text("Inbound Reports", 40, 45);
                            (PDF as any).autoTable({
                                head: [['Partner Name', 'Inbound Doc Count']],
                                foot: [['Total inbound volumes', this.inboundVolumeCount]],
                                body: response.inbound,
                                theme: 'grid',
                                margin: { right: 90 },
                                startY: 50,
                                columnStyles: {
                                    0: {
                                        cellWidth: 50
                                    },
                                    1: {
                                        cellWidth: 30
                                    },
                                }
                            });
                            PDF.setPage(2);
                            PDF.text("Outbound Reports", 130, 45);
                            (PDF as any).autoTable({
                                head: [['Partner Name', 'Outbound Doc Count']],
                                foot: [['Total outbound volumes', this.outboundVolumeCount]],
                                body: response.outbound,
                                theme: 'grid',
                                margin: { left: 110 },
                                startY: 50,
                                columnStyles: {
                                    0: {
                                        cellWidth: 50
                                    },
                                    1: {
                                        cellWidth: 30
                                    },
                                }
                            })
                            PDF.save("TP_Volumes_Reports_" + this.datepipe.transform(date, "ddMMyyyy_HHmm","+0000"));
                            this.pdfDisable=false;
                        });
                    });
                },
                (error) => {
                    //console.log("Error occured" + error);
                    this.pdfDisable=false;
                }
            );
    }
    allTradingPartners() {
        let headers = new HttpHeaders();
        headers = headers.append(
            "Authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(environment.apiUrl + "/partner/all", { headers: headers })
            .subscribe(
                (data: any) => {
                        this.allTradingPartner=data;
                        this.allTradingPartner=this.allTradingPartner.map(element=>({...element,optionLabel:`${element.label}(${element.value})`}))
                        this.allTradingPartner.splice(0, 0, { label: "All", value: "All",optionLabel:"All" })
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            );
        return this.allTradingPartners;
    }
}
